import OffAccountDialog from "./OffAccount"

const obj = {}

obj.install = function (Vue) {
    //1.创建组件构造器
    const Construct = Vue.extend(OffAccountDialog)

    //2.用new 的方式用组件构造器创建出来组件对象
    const offAccount = new Construct()

    //3.将组件对象手动挂载到某一个元素上
    offAccount.$mount(document.createElement('div'))

    //4.upperTip.$el对应的就是div
    document.body.appendChild(offAccount.$el)

    //5.在原型中加入UpperTip
    Vue.prototype.$OffAccountDialog = offAccount

}

export default obj
